export const truncateId = (eventId = '') => eventId.substring(0, 8);
